import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';

import { useApi } from 'landing-page/hooks/useApi';
import { api, BlogPageDataType } from 'landing-page/helpers/api';

import MainLayout from 'landing-page/components/layouts/MainLayout';
import Section from 'landing-page/components/common/Section';
import Container from 'landing-page/components/common/Container';
// import SimpleSearchInput from 'landing-page/components/common/SearchInput/SimpleSearchInput';
import HighlightCard from 'landing-page/components/common/HighlightCard'

import { BlogPlaceholder } from 'landing-page/pages/Blog/Placeholder';

// import SearchInput from 'landing-page/components/common/SearchInput';
// import AdvancedSearchInput from 'landing-page/components/common/SearchInput/AdvancedSearchInput';

const Blog: React.FC = () => {

    const [blogData, setBlogData] = useState<BlogPageDataType | null>(null);

    const { data, execute: fetchBlogData, loading } = useApi(api.getBlogPage.bind(api));

    useEffect(() => {
        fetchBlogData();
    }, []);

    useEffect(() => {
        if (data?.data) {
            setBlogData(data.data as unknown as BlogPageDataType);
        }
    }, [data]);

    // // Mock suggestions for demonstration
    // const searchSuggestions = [
    //     { id: '1', text: 'Rempah Nusantara', category: 'Artikel' },
    //     { id: '2', text: 'Trem Otonom', category: 'Teknologi' },
    //     { id: '3', text: 'Bakar Batu', category: 'Budaya' },
    //     { id: '4', text: 'Pertanian', category: 'Inovasi' },
    //     { id: '5', text: 'Energi Terbarukan', category: 'Lingkungan' }
    // ];

    // const handleSearch = (searchTerm: string) => {
    //     console.log('Searching for:', searchTerm);
    //     // Implement search functionality here
    // };

    // const handleSuggestionSelect = (suggestion: any) => {
    //     console.log('Selected suggestion:', suggestion);
    //     // Handle suggestion selection
    // };

    if (loading || !blogData) {
        return (
            <MainLayout>
                <Section variant="white" id="blog-page" className='mt-15'>
                    <BlogPlaceholder />
                </Section>
            </MainLayout>
        );
    }

    return (
        <MainLayout>
            <Section variant="white" id="blog-page" className='mt-15'>
                <Container className={clsx('', 'py-10')}>
                    <div className='row d-flex w-100'>
                        <div className='col-md-8'>
                            {/* highlight blog card */}
                            <div className='mb-10'>
                                <HighlightCard
                                    title={blogData?.highlight?.judul ?? ''}
                                    image={blogData?.highlight?.upload_thumbnail ?? ''}
                                    link={`/blog/${blogData?.highlight?.id}`}
                                    created_at={blogData?.highlight?.created_at ?? ''}
                                    category={blogData?.highlight?.kategori?.nama_kategori ?? ''}
                                    height='460px'
                                />
                            </div>

                            {/* blog list cards */}
                            <div className='row gap-10 d-flex flex-column flex-nowrap align-items-center w-100 m-0'>
                                {blogData?.news?.map((item, index) => (
                                    <div className='col p-0' key={item.id ?? index}>
                                        <Link to={`/blog/${item.id}`} className='text-decoration-none text-dark'>
                                        <Card className='border-0 shadow-sm rounded-4 overflow-hidden h-100'>
                                            <div className='row g-0' style={{height: '280px'}}>
                                                <div className='col-5'>
                                                    <div className='position-relative h-100'>
                                                        <Card.Img 
                                                            src={item.upload_thumbnail ?? ''} 
                                                            alt="Blog post"
                                                            className='h-100'
                                                            style={{ objectFit: 'cover' }}
                                                        />
                                                        {/* Dark overlay */}
                                                        <div 
                                                            className='position-absolute top-0 start-0 w-100 h-100' 
                                                            style={{ 
                                                                background: 'rgba(0, 0, 0, 0.2)',
                                                                zIndex: 1
                                                            }}
                                                        ></div>
                                                        
                                                        {/* Date tag */}
                                                        <div className='position-absolute top-0 start-0 m-2' style={{ zIndex: 2 }}>
                                                            <div className='bg-primary text-white p-2 rounded-2 small fw-bold' style={{ width: '42px', height: '42px' }}>
                                                                <div className='fw-bold fs-5 m-0 text-center' style={{ lineHeight: '1' }}> 
                                                                    {item.created_at && new Date(item.created_at).getDate() || '-'}
                                                                </div>
                                                                <div className='fw-normal fs-7 m-0 text-center'>
                                                                    {item.created_at && new Date(item.created_at).toLocaleDateString('en-US', { month: 'short' }) || '-'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-7'>
                                                    <Card.Body className='d-flex flex-column w-100' style={{height: '280px'}}>
                                                        <div className='d-flex align-items-center gap-2 mb-2'>
                                                            <i className='bi bi-tag text-primary'></i>
                                                            <span className='small text-muted'>{item.kategori?.nama_kategori}</span>
                                                        </div>
                                                        <h4
                                                            className='fw-bold mb-2'
                                                            style={{ 
                                                                display: '-webkit-box',
                                                                WebkitLineClamp: 4,
                                                                lineClamp: 4,
                                                                WebkitBoxOrient: 'vertical',
                                                                overflow: 'hidden',
                                                                lineHeight: '1.4',
                                                                textTransform: 'unset'
                                                            }}
                                                        >
                                                            {item.judul}
                                                        </h4>
                                                        <div className='mt-auto'>
                                                            <span className="text-primary fs-4 fw-bold d-flex align-items-center gap-2 card-link">
                                                                {'Selengkapnya'}
                                                                <i className="bi bi-arrow-right fs-4 text-primary arrow-hover"></i>
                                                            </span>
                                                        </div>
                                                    </Card.Body>
                                                </div>
                                            </div>
                                        </Card>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className='col-md-4'>
                            {/* Search */}
                            {/* Disable for now */}
                            {/* <Card className='mb-10 border-0 shadow-none rounded-4 overflow-hidden' style={{backgroundColor: '#FFF6F5'}}>
                                <Card.Body>
                                    <Card.Title as='h4' className='fw-bold' style={{textTransform: 'unset'}}>
                                        Cari Disini
                                    </Card.Title>

                                    <SimpleSearchInput
                                        placeholder='Judul artikel...'
                                        onSearch={handleSearch}
                                    />
                                </Card.Body>
                            </Card> */}

                            {/* Newest Post */}
                            <Card className='mb-10 border-0 shadow-none rounded-4 overflow-hidden' style={{backgroundColor: '#FFF6F5'}}>
                                <Card.Body>
                                    <Card.Title as='h4' className='fw-bold' style={{textTransform: 'unset'}}>Artikel Terbaru</Card.Title>
                                    
                                    <div className='row gap-5 d-flex flex-column flex-nowrap align-items-center w-100 m-0'>
                                        {blogData?.terbaru?.map((item, index) => (
                                            <div className='col p-0' key={item.id ?? index}>
                                                <Link to={`/blog/${item.id}`} className='text-decoration-none text-dark'>
                                                <Card className='border-0 shadow-none rounded-4 overflow-hidden h-100 bg-transparent'>
                                                    <div className='row g-0' style={{height: '120px'}}>
                                                        <div className='col-5'>
                                                            <div className='position-relative h-100'>
                                                                <Card.Img 
                                                                    src={item.upload_thumbnail ?? ''} 
                                                                    alt="Blog post"
                                                                    className='h-100'
                                                                    style={{ objectFit: 'cover' }}
                                                                />
                                                                {/* Dark overlay */}
                                                                <div 
                                                                    className='position-absolute top-0 start-0 w-100 h-100' 
                                                                    style={{ 
                                                                        background: 'rgba(0, 0, 0, 0.2)',
                                                                        zIndex: 1
                                                                    }}
                                                                ></div>
                                                                
                                                                {/* Date tag */}
                                                                <div className='position-absolute top-0 start-0 m-2' style={{ zIndex: 2 }}>
                                                                    <div className='bg-primary text-white p-2 rounded-2 small fw-bold' style={{ width: '42px', height: '42px' }}>
                                                                        <div className='fw-bold fs-5 m-0 text-center' style={{ lineHeight: '1' }}> 
                                                                            {item.created_at && new Date(item.created_at).getDate() || '-'}
                                                                        </div>
                                                                        <div className='fw-normal fs-7 m-0 text-center'>
                                                                            {item.created_at && new Date(item.created_at).toLocaleDateString('en-US', { month: 'short' }) || '-'}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-7'>
                                                            <Card.Body className='d-flex flex-column w-100 p-5' style={{height: '120px'}}>
                                                                <div className='d-flex align-items-center gap-2 mb-2'>
                                                                    <i className='bi bi-tag text-primary'></i>
                                                                    <span className='small text-muted'>{item.kategori?.nama_kategori}</span>
                                                                </div>
                                                                <h5
                                                                    className='fw-bold mb-2'
                                                                    style={{ 
                                                                        display: '-webkit-box',
                                                                        WebkitLineClamp: 2,
                                                                        lineClamp: 2,
                                                                        WebkitBoxOrient: 'vertical',
                                                                        overflow: 'hidden',
                                                                        lineHeight: '1.4',
                                                                        textTransform: 'unset'
                                                                    }}
                                                                >
                                                                    {item.judul}
                                                                </h5>
                                                                {/* <p className='text-muted mb-0 ellipsis-5'>
                                                                    {item.description}
                                                                </p> */}
                                                                {/* <div className='mt-auto'>
                                                                    <a href={item.link_url} className="text-primary fs-4 fw-bold d-flex align-items-center gap-2 card-link">
                                                                        {item.link_text}
                                                                        <i className="bi bi-arrow-right fs-4 text-primary arrow-hover"></i>
                                                                    </a>
                                                                </div> */}
                                                            </Card.Body>
                                                        </div>
                                                    </div>
                                                </Card>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                </Card.Body>
                            </Card>

                            {/* Categories */}
                            <Card className='mb-10 border-0 shadow-none rounded-4 overflow-hidden' style={{backgroundColor: '#FFF6F5'}}>
                                <Card.Body>
                                    <Card.Title as='h4' className='fw-bold' style={{textTransform: 'unset'}}>Kategori</Card.Title>

                                    <div className='d-flex flex-column gap-4 mt-5'>
                                        {blogData?.categories?.map((item, index) => (
                                            <div className='d-flex align-items-center justify-content-between gap-2' key={index}>
                                                <span className='text-dark fs-5 fw-semibold'>{item.nama_kategori}</span>
                                                <span className='text-dark fs-5'>{item.jumlah_berita ?? 0}</span>
                                            </div>
                                        ))}
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                </Container>
            </Section>
        </MainLayout>
    );
};

export default Blog;